/** Where a QC page's back link goes: the whole Runs list (no type filter). */
export function useQcBackLink(): { to: string; label: string; search?: Record<string, string> } {
  return { to: '/content/runs', label: 'Runs' };
}
